import RestAPI from "../../../util/RestAPI";

// use groupList as type options for group
export async function joinMailGroup(
  group:
    | "viewed-pricing"
    | "abandoned-checkout"
    | "generated-lesson"
    | "generated-quiz"
    | "created-class"
    | "assigned-game"
) {
  try {
    await RestAPI.put(`/mail/add-group/${group}`);
  } catch (err) {
    console.error(err);
  }
}
